import { SyncEvent, VoidSyncEvent } from 'ts-events';
import jDataView from 'jdataview';
import jBinary from 'jbinary';
import { caseInsensitiveMatch } from './util';
import { netStringTypeset } from './util/net-string';
import { unpackFrameDataB } from './util/crypto';
import { unpackFrameDataC } from './util/crypto';
import { screenConnection as sC, TraversalConnection } from './socket';
import { screenShareStarted } from './socket';
import * as _ from 'lodash';

function trimBuffer(bufferArray: Uint8Array) {
  let lastByte = bufferArray.length - 1;
  while (bufferArray[lastByte] == 0) {
    lastByte--;
  }
  return bufferArray.subarray(0, lastByte + 1);
}

function endpointSendFn(
  getSyncKey: () => string,
  sendPacket: (packet: any, endpoint: string) => any,
) {
  return function(action: string, args?) {
    let packet: any = {
      endpoint: action.toLowerCase(),
      synckey: getSyncKey(),
    };
    if (typeof args !== 'undefined') {
      if (args instanceof Array) {
        packet.args = args;
      } else {
        packet.args = [args];
      }
    }
    return sendPacket(packet, packet.endpoint);
  };
}

export class SocketConnection {
  socket: WebSocket;
  connected: boolean = false;
  username: string = '';
  password: string = '';
  hasServer: boolean = false;
  serverId: string = '';
  private currentSyncKey = 0;
  resolves: { [syncKey: string]: (arg: any) => any } = {};
  events = {
    successAnswer: new SyncEvent<any>(),
    offerReply: new SyncEvent<any>(),
    iceCandidate: new SyncEvent<any>(),
    noslave: new SyncEvent<any>(),
    credAnswer: new SyncEvent<any>(),
    authAnswer: new SyncEvent<any>(),
    noSlaveAnswer: new SyncEvent<any>(),
    open: new SyncEvent<Event>(),
    close: new SyncEvent<Event>(),
  };
  commands: { [key: string]: Function };
  serverCommands: { [key: string]: Function };
  constructor() {
    this.commands = {
      requestcreds: obj => {
        console.log('Credentials got.');
        this.username = obj.results.tempCreds.username;
        this.password = obj.results.tempCreds.password;
        this.authenticate(this.username, this.password);
        //this.events.credAnswer.post(obj)
      },
      authenticate: obj => {
        //this.events.authAnswer.post(obj)
        console.log('Authenticated.');
        this.setServer('CE751CA11');
        this.events.open.post(obj);
      },
      noslave: obj => {
        this.events.noSlaveAnswer.post(obj);
      },
      offerreply: obj => {
        this.events.offerReply.post(obj);
      },
      successreply: obj => {
        this.events.successAnswer.post(obj);
      },
      icereply: obj => {
        this.events.iceCandidate.post(obj);
      },
    };
    this.serverCommands = {};
  }
  private getSyncKey = () => {
    return String(this.currentSyncKey++);
  };
  setServer(id: string) {
    this.serverId = id;
    this.hasServer = true;
  }
  connect(host: string) {
    this.socket = new WebSocket(host);
    this.socket.binaryType = 'arraybuffer';
    let socket = this.socket;
    socket.onopen = ev => {
      console.log('Socket opened.');
      this.connected = true;
      //this.events.open.post(ev)
      this.getCredentials();
    };
    socket.onclose = ev => {
      var inputElement = <HTMLInputElement>document.getElementById('connect');
      inputElement.disabled = false;
      this.connected = false;
      this.events.close.post(ev);
    };
    socket.onmessage = e => {
      let msg;
      if (this.hasServer) {
        msg = JSON.parse(this.unpackMessage(e.data).body);
      } else {
        msg = JSON.parse(e.data);
      }
      //LOG console.log(msg)
      let command = msg.endpoint;
      typeof this.commands[msg.endpoint] === 'function' &&
        this.commands[msg.endpoint](msg);
      if (msg.syncKey && typeof this.resolves[msg.syncKey] === 'function') {
        this.resolves[msg.syncKey](msg.results);
        delete this.resolves[msg.syncKey];
      }
    };
    socket.onerror = e => {
      console.log('Error in SocketConnection:', e);
    };
  }
  packMessage(
    target: 'Server' | 'Pass',
    packet: any,
    recipient?: string,
  ): Uint8Array {
    //LOG console.log(packet)
    let packetString =
      typeof packet === 'string' ? packet : JSON.stringify(packet);
    let bufferLength =
      packetString.length +
      2 +
      target.length +
      2 +
      (recipient ? recipient.length + 2 : 0);
    let v = new jBinary(
      new jDataView(bufferLength, 0, bufferLength, true),
      netStringTypeset,
    );
    v.write('NET_String', target);
    recipient && v.write('NET_String', recipient);
    v.write('NET_String', packetString);
    return trimBuffer(new Uint8Array(v.view.buffer));
    /*
        let bufferArray = new Uint8Array(v.view.buffer)
        let lastByte = bufferArray.length - 1
        while (bufferArray[lastByte] == 0) {
            lastByte--
        }
        return bufferArray.subarray(0, lastByte + 1) */
  }
  unpackMessage(buffer: Uint8Array) {
    //LOG console.log(buffer)
    let v = new jBinary(
      new jDataView(buffer, 0, buffer.length, true),
      netStringTypeset,
    );
    let senderId = v.read('NET_String');
    let body = v.read('NET_String');
    return { senderId, body };
  }
  authenticate(username: string, password: string) {
    return this.send('authenticate', [username, password, 'Master']);
  }
  getCredentials() {
    return this.send('requestcreds');
  }
  send: (action: string, args?: any[]) => Promise<any> = endpointSendFn(
    this.getSyncKey,
    packet => {
      return new Promise<any>((resolve, reject) => {
        this.socket.send(this.packMessage('Server', packet));
        this.resolves[packet.synckey] = resolve;
        //LOG console.log(this.resolves)
      });
    },
  );
  sendRawToServer(data: string) {
    if (this.hasServer) {
      this.socket.send(this.packMessage('Pass', data, this.serverId));
    } else {
      throw 'Attempted to send to server before connecting to server';
    }
    /*
        try {
            this.socket.send(data)
        }
        catch (e) {
            console.log("Send failed.", e)
        } */
  }
  disconnect() {
    this.socket.close();
  }
}

interface Callback {
  (message: any, stream: RTCStream): any;
}

interface KeyPredicate {
  (key: string, message: any, stream: RTCStream): boolean;
}

export class RTCStream {
  correlationId: number = 1;

  servers = {
    //iceTransportPolicy: 'relay', // force turn
    iceServers: [
      { urls: 'stun:stun.services.mozilla.org' },
      { urls: 'stun:stun3.l.google.com:19302' },
    ],
  };
  dataChannelOptions = {
    ordered: true,
    maxRetransmits: 1,
    negotiated: false,
  };
  pcOptions = {
    optional: [
      { DtlsSrtpKeyAgreement: true },
      //{ RtpDataChannels: true }
    ],
    //mandatory: {OfferToReceiveAudio: true, OfferToReceiveVideo: true}
  };
  offerOptions = {
    offerToReceiveAudio: 0,
    offerToReceiveVideo: 0,
    voiceActivityDetection: false,
    iceRestart: true,
  };
  vgaConstraints = { video: false, audio: false };
  remoteStream: RTCPeerConnection;
  //socketConnection: SocketConnection = new SocketConnection()
  connection: TraversalConnection;
  dataChannel: RTCDataChannel;
  get channelOpen(): boolean {
    if (!this.dataChannel) {
      return false;
    }
    return (
      this.remoteStream.iceConnectionState == 'connected' &&
      this.dataChannel.readyState == 'open'
    );
  }
  remoteAnswer: string;
  localIce: any[] = [];
  localIceWs: any[] = [];
  testMsgCount = 0;
  reconnectionInterval;
  currentSynckey = 0;
  commands: { [key: string]: Function };
  keyedListeners: {
    predicate: KeyPredicate;
    callbacks: { [key: string]: Callback };
  }[] = [];
  events = {
    noSlaveAnswer: new SyncEvent<any>(),
    offerReply: new SyncEvent<any>(),
    successAnswer: new SyncEvent<any>(),
    iceCandidate: new SyncEvent<any>(),
    open: new SyncEvent<any>(),
    channelOpen: new VoidSyncEvent(),
    channelClose: new VoidSyncEvent(),
  };
  chunkedPackets: { [id: number]: Uint8Array } = {};

  constructor() {
    window.addEventListener('beforeunload', ev => {
      this.closeDataChannel();
    });

    this.connect('');
    this.commands = {
      requestcreds: obj => {
        console.log('Credentials got.');
        //this.username = obj.results.tempCreds.username
        //this.password = obj.results.tempCreds.password
        //this.authenticate(this.username, this.password)
        //this.events.credAnswer.post(obj)
      },
      authenticate: obj => {
        //this.events.authAnswer.post(obj)
        console.log('Authenticated.');
        //this.events.open.post(obj)
      },
      noslave: obj => {
        this.events.noSlaveAnswer.post(obj);
      },
      offerreply: obj => {
        this.events.offerReply.post(obj);
      },
      successreply: obj => {
        this.events.successAnswer.post(obj);
      },
      icereply: obj => {
        this.events.iceCandidate.post(obj);
      },
    };
  }

  setConnection(c: TraversalConnection) {
    this.connection = c;
    this.setConnectionEvents();
    return this;
  }
  setConnectionEvents() {
    this.connection.events.message.attach(msg => {
      //console.log("RTC stream got message " + msg.endpoint)
      if (typeof this.commands[msg.endpoint.toLowerCase()] === 'function') {
        this.commands[msg.endpoint.toLowerCase()](msg);
      }
    });
    this.connection.haveServer.then(() => {
      console.log('RTC connection opening');
      this.events.open.post({});
    });
  }
  getSyncKey = () => {
    return String(this.currentSynckey++);
  };
  startStream() {
    console.log('Start stream.');
    //becus types r wrong
    this.remoteStream = new (RTCPeerConnection as any)(
      this.servers,
      this.pcOptions,
    );
    this.dataChannel = this.remoteStream.createDataChannel(
      'msgDataChannel',
      this.dataChannelOptions,
    );

    (this.remoteStream as any).onaddstream = event => {
      try {
        console.log('Added stream.');
      } catch (e) {
        console.log('Failed to connect stream!', e);
        //this.socketConnection.disconnect()
      }
    };

    this.remoteStream.onconnectionstatechange = ev => {
      console.log(
        'RTCPeerConnection connection state changed: ',
        this.remoteStream.connectionState,
      );
      if (this.remoteStream.connectionState == 'failed') {
        this.startStream();
      }
    };

    this.remoteStream.oniceconnectionstatechange = event => {
      let stream = this.remoteStream;
      console.info('iceConnectionState: ' + stream.iceConnectionState);
      if (stream.iceConnectionState === 'failed') {
        console.warn('Ice Connection is failed. Reconnect...');
        this.startStream();
      }
    };

    this.remoteStream.onicecandidate = event => {
      if (event.candidate) {
        let ice = parseIce(event.candidate.candidate);
        if (ice && ice.component_id == 1 && ice.localIP.indexOf(':') < 0) {
          console.log('Ice candidate (local): ' + event.candidate.candidate);
          var iceRequest = {
            endpoint: 'onicecandidate',
            args: [
              event.candidate.candidate,
              event.candidate.sdpMid,
              event.candidate.sdpMLineIndex,
            ],
          };
          this.connection.sendRawToServer(iceRequest);
          this.localIce.push(ice);
        } else {
          console.log(
            'Ice candidate (local, skipped): ' + event.candidate.candidate,
          );
        }
      } else {
        console.log('Ice candidate (complete).');
      }
    };

    this.remoteStream.onnegotiationneeded = event => {
      console.log('Negotiation needed.');
      this.sendOffer();
    };
  }
  sendOffer() {
    console.log('Creating offer.');
    this.remoteStream.createOffer(
      (desc: RTCSessionDescriptionInit) => {
        this.remoteStream
          .setLocalDescription(
            desc,
            () => {
              var offerRequest = {
                endpoint: 'offer',
                args: [desc.sdp],
              };
              this.connection.sendRawToServer(offerRequest);
            },
            errorInformation => {
              console.log('Set local description error: ' + errorInformation);
            },
          )
          .then(() => {
            this.setDataChannelEvents();
          });
      },
      error => {
        console.log(error);
        //this.connection.disconnect()
      },
      this.offerOptions,
    );
  }
  logElementToConsole(element) {}
  unpackMessage(binaryMessage: Uint8Array) {
    if (binaryMessage.length === 0) {
      console.error('Empty message received', binaryMessage);
      return;
    }

    let v = new jBinary(
      new jDataView(binaryMessage, 0, binaryMessage.length, true),
      netStringTypeset,
    );
    let endpoint = v.read('NET_String');
    //console.log(endpoint)
    const endpointMatches = endpointStr =>
      caseInsensitiveMatch(endpoint, endpointStr);
    let message;
    if (endpointMatches('chunk')) {
      let id = v.read('int32');
      let streamLength = v.read('int64');
      let chunkIndex = v.read('int32');
      let isLast = Boolean(v.read('byte'));
      let body = v.read('blob') as Uint8Array;
      if (!this.chunkedPackets[id]) {
        this.chunkedPackets[id] = body;
      } else {
        let newChunk = new Uint8Array(
          this.chunkedPackets[id].length + body.length,
        );
        newChunk.set(this.chunkedPackets[id], 0);
        newChunk.set(body, this.chunkedPackets[id].length);
        this.chunkedPackets[id] = newChunk;
      }

      if (isLast) {
        this.unpackMessage(this.chunkedPackets[id]);
        delete this.chunkedPackets[id];
      }

      return;
    } else if (endpointMatches('screensharedata')) {
      message = {
        endpoint: 'screensharedata',
        results: unpackFrameDataB(v),
      };
    } else if (endpointMatches('screensharedatac')) {
      message = {
        endpoint: 'screensharedata',
        results: unpackFrameDataC(v),
      };
    } else {
      let header = JSON.parse(v.read('NET_String'));
      if (header.results) {
        message = header;
      } else {
        message = {
          endpoint: endpoint,
          results: header,
        };

        let binary = new Uint8Array((v as any).view.buffer).subarray(v.tell());
        if (binary.length > 0) {
          _.assign(message.results, { binary });
        }

        if (header.correlationId) {
          let correlationId = header.correlationId;
          _.assign(message, { correlationId });
        }
      }
    }

    //console.log(message)
    this.onDataChannelMessage(message);
  }
  packMessage(message: string, prefix?: number[]) {
    let bufferLength = (prefix ? prefix.length : 0) + message.length + 4;
    let v = new jBinary(
      new jDataView(bufferLength, 0, bufferLength, true),
      netStringTypeset,
    );
    if (prefix) {
      v.write(['array', 'byte'], prefix);
    }

    v.write('NET_String', message);

    let bufferArray = new Uint8Array(v.view.buffer);
    return bufferArray.subarray(0, v.view.tell());
  }
  /*
    sendToDataChannel = endpointSendFn(this.getSyncKey, (packet) => {
        this.dataChannel.send(this.packMessage(JSON.stringify(packet)))
    })
*/
  setDataChannelEvents() {
    const dc = this.dataChannel;
    console.group('Setting data channel events...');
    console.log(`Channel ${dc.id}: ${dc.label}`);
    console.groupEnd();
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    dc.onmessage = e => {
      // Workaround for Firefox
      // For some reason firefox get data from WebRTC as Blob and not as ArrayBuffer (as Chrome does)
      // So we need to convert it. Not sure how it affects the performance
      if (isFirefox) {
        let arrayBuffer;
        const fileReader = new FileReader();
        fileReader.onload = (event: any) => {
          arrayBuffer = new Uint8Array(event.target.result);
          this.unpackMessage(arrayBuffer);
        };
        fileReader.readAsArrayBuffer(e.data);
      } else {
        this.unpackMessage(new Uint8Array(e.data));
      }
    };
    dc.onopen = () => {
      console.log('Datachannel opened');
      clearInterval(this.reconnectionInterval);
      this.events.channelOpen.post();
      this.connection.sendRawToServer({ endpoint: 'confirmconnection' });
      // Reconnect was previous not working.  This likely isn't needed now
      // since the agent is handling restart of screen sharing on events like
      // Windows user/session switching.
      //if (screenShareStarted) {
      //  console.log(`sending startscreenshare from WebRtc recoonect`);
      //  sC.callEndpoint('startscreenshare');
      //}
    };
    dc.onclose = () => {
      console.log('Data channel closed.');
      this.events.channelClose.post();
    };
    dc.onerror = e => {
      console.log('Error on RTC channel:', e);
    };
  }

  onDataChannelMessage(message: any) {
    if (message.endpoint) {
      for (let listener of this.keyedListeners) {
        _.forOwn(listener.callbacks, (fn, name) => {
          if (listener.predicate(name, message, this)) {
            let removeListener = fn(message.results, this);
            if (removeListener === true) {
              _.pull(this.keyedListeners, listener);
            }
          }
        });
      }
    }
  }

  closeDataChannel() {
    if (this.dataChannel) {
      this.dataChannel.close();
      console.log('DataChannel closed.');
    }
  }
  /*
    authenticate() {
        var authenticateRequest = {
            endpoint: "authenticate",
            args: [this.socketConnection.username, this.socketConnection.password, "Master"]
        }
        const obj = JSON.stringify(authenticateRequest)
        this.socketConnection.sendRawToServer(obj)
    } */
  send(message: string) {
    if (this.dataChannel) {
      this.dataChannel.send(message);
    }
  }

  sendAsyncBatch(
    type: string,
    restOfPacket: any,
    callback: (message: any) => any,
  ): number {
    //console.log("RTC sendAsyncBatch")
    let correlationId = this.nextCorrelationId();
    let packet = {
      endpoint: type.toLowerCase(),
      args: [_.assign({}, restOfPacket, { correlationId })],
    };

    this.dataChannel.send(JSON.stringify(packet));
    this.listenKeys(
      (name: string, msg: any) =>
        msg.correlationId && msg.correlationId == correlationId,
      {
        _(msg: any) {
          callback(msg);
        },
      },
    );

    return correlationId;
  }

  callEndpoint(type: string, args: any) {
    let packet = {
      endpoint: type.toLowerCase(),
      args,
    };

    this.dataChannel.send(JSON.stringify(packet));
  }

  sendFileHeader(jsonMessage: any) {
    if (this.dataChannel) {
      let emptyGuidKey = [];
      for (var i = 0; i < 16; i++) emptyGuidKey.push(0);
      this.dataChannel.send(
        this.packMessage(JSON.stringify(jsonMessage), emptyGuidKey),
      );
    }
  }

  sendFileStream(data: any): Promise<void> {
    return this.sendDataAsync(data);
  }

  sendDataAsync(data: any): Promise<any> {
    return new Promise(resolve => {
      if (this.dataChannel) {
        // Stop checking and resolve promise after buffer has
        // gone down below 50k.
        var checkInterval = setInterval(() => {
          if (this.dataChannel.bufferedAmount < 50000) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 10);
        this.dataChannel.send(data);
      } else {
        resolve();
      }
    });
  }

  /*
    requestCreds() {
        var credRequest = {
            endpoint: "requestcreds"
        }
        const obj = JSON.stringify(credRequest)
        console.log(obj)
        this.socketConnection.sendRawToServer(obj)
    } */
  connect(host: string) {
    //const sock = this.socketConnection
    //this.events.open.attach(() => {
    //this.requestCreds()
    //this.startStream()
    //})
    /*
        this.events.close.attach(() => {
            console.log("Close")
        }) */
    this.events.successAnswer.attach(obj => {
      if (this.remoteStream) {
        console.log('Success answer (remote): ' + obj.results[0]);
        this.remoteAnswer = obj.results[0];
        this.remoteStream.setRemoteDescription(
          new RTCSessionDescription({ type: 'answer', sdp: this.remoteAnswer }),
          () => {},
          error => {
            console.log('Set remote description error: ' + error);
          },
        );
      }
    });
    this.events.offerReply.attach(obj => {
      if (obj.results.status === true) {
        console.log('HEllo');
        //this.sendIce()
      }
    });
    /*
        this.events.credAnswer.attach(obj => {
            this.authenticate()
        })
        */
    this.events.open.attach(obj => {
      console.log('Ready to send messages');
      this.startStream();
    });
    this.events.noSlaveAnswer.attach(obj => {});
    this.events.iceCandidate.attach(obj => {
      if (this.remoteStream) {
        console.log(
          'Ice candidate (remote): ' +
            obj.results[0] +
            ' / ' +
            obj.results[1] +
            ' / ' +
            obj.results[2],
        );
        let c = new RTCIceCandidate({
          sdpMid: obj.results[0],
          sdpMLineIndex: obj.results[1],
          candidate: obj.results[2],
        });
        this.remoteStream.addIceCandidate(c);
      }
    });
    //sock.connect(host)
  }

  listenKeys(predicate: KeyPredicate, callbacks: { [key: string]: Callback }) {
    this.keyedListeners.push({ predicate, callbacks });
  }

  nextCorrelationId() {
    return this.correlationId++;
  }
}

function parseIce(candidateString) {
  // token                  =  1*(alphanum / "-" / "." / "!" / "%" / "*"
  //                              / "_" / "+" / "`" / "'" / "~" )
  var token_re = "[0-9a-zA-Z\\-\\.!\\%\\*_\\+\\`\\'\\~]+";

  // ice-char               = ALPHA / DIGIT / "+" / "/"
  var ice_char_re = '[a-zA-Z0-9\\+\\/]+';

  // foundation             = 1*32ice-char
  var foundation_re = ice_char_re;

  // component-id           = 1*5DIGIT
  var component_id_re = '[0-9]{1,5}';

  // transport             = "UDP" / transport-extension
  // transport-extension   = token      ; from RFC 3261
  var transport_re = token_re;

  // priority              = 1*10DIGIT
  var priority_re = '[0-9]{1,10}';

  // connection-address SP      ; from RFC 4566
  var connection_address_v4_re =
    '[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}';
  var connection_address_v6_re = '\\:?(?:[0-9a-fA-F]{0,4}\\:?)+'; // fde8:cd2d:634c:6b00:6deb:9894:734:f75f

  var connection_address_re =
    '(?:' + connection_address_v4_re + ')|(?:' + connection_address_v6_re + ')';

  // port                      ; port from RFC 4566
  var port_re = '[0-9]{1,5}';

  //  cand-type             = "typ" SP candidate-types
  //  candidate-types       = "host" / "srflx" / "prflx" / "relay" / token
  var cand_type_re = token_re;

  var ICE_RE =
    '(?:a=)?candidate:(' +
    foundation_re +
    ')' + // candidate:599991555 // 'a=' not passed for Firefox (and now for Chrome too)
    '\\s' +
    '(' +
    component_id_re +
    ')' + // 2
    '\\s' +
    '(' +
    transport_re +
    ')' + // udp
    '\\s' +
    '(' +
    priority_re +
    ')' + // 2122260222
    '\\s' +
    '(' +
    connection_address_re +
    ')' + // 192.168.1.32 || fde8:cd2d:634c:6b00:6deb:9894:734:f75f
    '\\s' +
    '(' +
    port_re +
    ')' + // 49827
    '\\s' +
    'typ' + // typ
    '\\s' +
    '(' +
    cand_type_re +
    ')' + // host
    '(?:' +
    '\\s' +
    'raddr' +
    '\\s' +
    '(' +
    connection_address_re +
    ')' +
    '\\s' +
    'rport' +
    '\\s' +
    '(' +
    port_re +
    ')' +
    ')?' +
    '(?:' +
    '\\s' +
    'generation' + // generation
    '\\s' +
    '(' +
    '\\d+' +
    ')' + // 0
    ')?' +
    '(?:' +
    '\\s' +
    'ufrag' + // ufrag
    '\\s' +
    '(' +
    ice_char_re +
    ')' + // WreAYwhmkiw6SPvs
    ')?';

  var pattern = new RegExp(ICE_RE);
  var parsed = candidateString.match(pattern);

  //console.log('parseIceCandidate(): candidateString:', candidateString);
  //console.log('parseIceCandidate(): pattern:', pattern);
  //console.log('parseIceCandidate(): parsed:', parsed);

  // Check if the string was successfully parsed
  if (!parsed) {
    console.warn("parseIceCandidate(): parsed is empty: '" + parsed + "'");
    return null;
  }
  var propNames = [
    'foundation',
    'component_id',
    'transport',
    'priority',
    'localIP',
    'localPort',
    'type',
    'remoteIP',
    'remotePort',
    'generation',
    'ufrag',
  ];

  var candObj = {};
  for (var i = 0; i < propNames.length; i++) {
    candObj[propNames[i]] = parsed[i + 1];
  }
  return candObj as {
    foundation: string;
    component_id: number;
    transport: string;
    priority: string;
    localIP: string;
    localPort: string;
    type: string;
    remoteIP: string;
    remotePort: string;
    generation: string;
    ufrag: string;
  };
}

function stringifyIce(iceCandObj) {
  var s =
    'candidate:' +
    iceCandObj.foundation +
    '' +
    ' ' +
    iceCandObj.component_id +
    '' +
    ' ' +
    iceCandObj.transport +
    '' +
    ' ' +
    iceCandObj.priority +
    '' +
    ' ' +
    iceCandObj.localIP +
    '' +
    ' ' +
    iceCandObj.localPort +
    '' +
    ' typ ' +
    iceCandObj.type +
    '' +
    (iceCandObj.remoteIP ? ' raddr ' + iceCandObj.remoteIP + '' : '') +
    (iceCandObj.remotePort ? ' rport ' + iceCandObj.remotePort + '' : '') +
    (iceCandObj.generation ? ' generation ' + iceCandObj.generation + '' : '') +
    (iceCandObj.ufrag ? ' ufrag ' + iceCandObj.ufrag + '' : '');
  return s;
}
